import { useScreenViewEvent, type UseScreenViewEventData } from '@stitch-fix/event-reporter';
type LandingScreenViewTrackingName = Extract<UseScreenViewEventData, {
  schema: 'screen_view';
}>['name'];
export type LandingScreenViewTrackingProps = {
  contentId?: 'refresh' | 'giveget_refresh' | 'refresh_results';
  name?: LandingScreenViewTrackingName;
  children: React.ReactNode;
};
export const LandingScreenViewTracking = ({
  contentId,
  name = 'landing',
  children
}: LandingScreenViewTrackingProps) => {
  const {
    EventProvider
  } = useScreenViewEvent({
    schema: 'screen_view',
    name,
    locale: 'en-US',
    region: 'US',
    source_app: 'growth-next-ui',
    content_id: contentId
  });
  return <EventProvider>{children}</EventProvider>;
};